module.exports = __webpack_public_path__ + "img/Plan2-1.2f3e950e.jpg";